import { render } from "./WithdrawRebate.vue?vue&type=template&id=630ce145"
import script from "./WithdrawRebate.vue?vue&type=script&lang=js"
export * from "./WithdrawRebate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__